import React from 'react';
import type { BackdropStyle } from '../../data/shopConfig';

// The storefront canvas. Merchants pick one of a few predefined treatments;
// every colour reads from the storefront's CSS variables, so one
// implementation serves both the public shop and the Settings preview.

interface ShopBackdropProps {
  /** Base page background resolved from the merchant's theme. */
  background: string;
  /** 0–1, how strongly the brand shows through the texture and washes. */
  strength: number;
  /** Which predefined treatment the merchant chose. */
  variant?: BackdropStyle;
}
export function ShopBackdrop({
  background,
  strength,
  variant = 'plain'
}: ShopBackdropProps) {
  const texture = variant === 'dots';
  const grid = variant === 'grid';
  const rings = variant === 'rings';
  const lines = variant === 'lines';
  const glow = variant !== 'plain';
  return <div className="absolute inset-0 pointer-events-none overflow-hidden z-0" aria-hidden="true" data-id="element-4741" data-mp="1uf6u0vxo0gez">
      <div className="absolute inset-0" style={{
      background
    }} data-id="element-4742" data-mp="2zzj6utu7bwvp" />

      {/* Micro dot texture */}
      {texture && <div className="absolute inset-0" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, var(--mp-10) 1px, transparent 0)',
      backgroundSize: '26px 26px',
      opacity: 0.4 + strength * 0.6
    }} data-id="element-4743" data-mp="2v2j0ehtfws42" />}

      {/* Hairline architectural grid */}
      {grid && <div className="absolute inset-0" style={{
      backgroundImage: 'linear-gradient(to right, var(--mp-07) 1px, transparent 1px), linear-gradient(to bottom, var(--mp-07) 1px, transparent 1px)',
      backgroundSize: '104px 104px',
      opacity: 0.5 + strength * 0.5
    }} data-id="element-4744" data-mp="3e0c1rfof0tzc" />}

      {/* Fine diagonal weave */}
      {lines && <div className="absolute inset-0" style={{
      backgroundImage: 'repeating-linear-gradient(135deg, var(--mp-07) 0 1px, transparent 1px 14px)',
      opacity: 0.45 + strength * 0.55
    }} data-id="element-4745" data-mp="lpavha3g7mc" />}

      {/* Concentric hairline arcs radiating behind the hero */}
      {rings && [0, 1, 2, 3, 4].map(i => <div key={i} className="absolute left-1/2 top-[2%] rounded-full border border-[var(--mp-10)] -translate-x-1/2" style={{
      width: `${420 + i * 300}px`,
      height: `${420 + i * 300}px`,
      opacity: (0.4 + strength * 0.6) * (1 - i * 0.14)
    }} data-id="element-4746" data-mp="3852e4wv8orr1" />)}

      {/* Ambient brand light */}
      {glow && <>
          <div className="absolute inset-x-0 top-0 h-[60%]" style={{
        background: 'radial-gradient(65% 100% at 50% 0%, var(--mp-08), transparent 72%)'
      }} data-id="element-4747" data-mp="3r2d05frv1ooj" />
          <div className="absolute inset-x-0 top-0 h-[40%]" style={{
        background: 'radial-gradient(38% 100% at 50% 0%, var(--ma-30), transparent 70%)',
        opacity: 0.28
      }} data-id="element-4748" data-mp="1wqots1zp2ufr" />
        </>}

      {/* White vignette keeps the centre column clear */}
      {variant !== 'plain' && <div className="absolute inset-0" style={{
      background: 'radial-gradient(125% 95% at 50% 42%, transparent 42%, rgba(255, 255, 255, 0.9) 100%)'
    }} data-id="element-4749" data-mp="1bfiwkgwjz804" />}
    </div>;
}